module.exports = __webpack_public_path__ + "static/shipping-date-notification-80d534990747aa87e510914ce2dffc9b.png";